<template>
  <div ref="useGuide" class="use-guide">
    <a-modal
      :get-container="() => ($refs.useGuide as HTMLElement)"
      :visible="true"
      :footer="null"
      centered
      @cancel="cancelM"
    >
      <template #closeIcon>
        <img class="icon-close" src="@assets/svgs/preload-icon-popper-close.svg" alt="" />
      </template>
      <div class="popper-title">{{ $t('owork_base.owork_user_guide.title') }}</div>
      <div class="content">
        <UseGuideWeb v-if="useElectron() === undefined" />
        <UseGuidePC v-else />
        <!-- <UseGuidePC /> -->
      </div>
      <div class="bottom-shadow"></div>
    </a-modal>
  </div>
</template>

<script lang="ts" setup>
  import UseGuidePC from './UseGuidePC.vue'
  import UseGuideWeb from './UseGuideWeb.vue'
  import { useElectron } from '@core/compositions/Electron'

  const emit = defineEmits(['cancel-use-guide'])

  const cancelM = () => {
    emit('cancel-use-guide', false)
  }
</script>

<style lang="stylus" scoped>
  @import '../../styles/settingModal.styl'

  .use-guide
    color default_color
    setting-model-style()
    .popper-title
      display inline-block
      rect(100%, 26px)
      line-height 26px
      font-weight bolder_font_weight
      margin-top 23px
      text-align center
      font-size 20px
    .content
      padding 6px 32px 40px
      overflow-y auto
      height 550px
      font-size 14px
      & > p
        line-height 20px
      & > .content-title:first-child
        margin-top 14px
      .content-title
        margin-top 24px
        title()
      .content-desc
        margin-top 6px
        sub-title()

  @import '../../styles/h5Adaptive/settingModal.styl'
</style>
